import { translations } from "../../data/translations";

export function getTimeDifferenceText(timestamp: string, lang: string): string {
  const t = translations as any;
  const currentTimestamp: Date = new Date();
  const givenTimestamp: Date = new Date(timestamp);

  const timeDifference: number = currentTimestamp.getTime() - givenTimestamp.getTime();
  const secondsDifference: number = Math.floor(timeDifference / 1000);
  const minutesDifference: number = Math.floor(secondsDifference / 60);
  const hoursDifference: number = Math.floor(minutesDifference / 60);
  const daysDifference: number = Math.floor(hoursDifference / 24);

  if (daysDifference >= 1) {
    return `${daysDifference} ${t["days ago"][lang]}`;
  } else if (hoursDifference >= 1) {
    return `${hoursDifference} ${t["hours ago"][lang]}`;
  } else if (minutesDifference >= 1) {
    return `${minutesDifference} ${t["minutes ago"][lang]}`;
  } else {
    return t["Just now"][lang];
  }
}

export const formatDate = (initialDate: string, format: "iso" | "display" = "iso"): string => {
  const dateObj = new Date(initialDate);
  const year = dateObj.getUTCFullYear();
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getUTCDate()).padStart(2, "0");

  return format === "iso" ? `${year}-${month}-${day}` : `${day}/${month}/${year}`;
};

export function formatUnixDate(unixTimestamp: number): string {
  const date = new Date(unixTimestamp * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function formatDateWithTime(dateString: string | undefined): string {
  if (!dateString) return "No previous deployment";

  const date = new Date(dateString);

  // Format date as DD/MM/YYYY (you know, as superior humans)
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  // Format time as HH:MM
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}

export function getRelativeTimeFromNow(dateString: string | undefined): string {
  if (!dateString) return "";

  const date = new Date(dateString);
  const now = new Date();

  // Calculate time difference
  const diffMs = now.getTime() - date.getTime();

  // Convert to days, hours, minutes
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  // Format the relative time string
  if (diffDays > 0) {
    return `${diffDays} ${diffDays === 1 ? "day" : "days"}${diffHours > 0 ? ` and ${diffHours} ${diffHours === 1 ? "hour" : "hours"}` : ""} ago`;
  } else if (diffHours > 0) {
    return `${diffHours} ${diffHours === 1 ? "hour" : "hours"}${diffMinutes > 0 ? ` and ${diffMinutes} ${diffMinutes === 1 ? "minute" : "minutes"}` : ""} ago`;
  } else if (diffMinutes > 0) {
    return `${diffMinutes} ${diffMinutes === 1 ? "minute" : "minutes"} ago`;
  } else {
    return "just now";
  }
}

export function timeAgo(dateString: string) {
  if (!dateString) return "never";
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) return Math.floor(interval) + " years ago";
  interval = seconds / 2592000;
  if (interval > 1) return Math.floor(interval) + " months ago";
  interval = seconds / 86400;
  if (interval > 1) return Math.floor(interval) + " days ago";
  interval = seconds / 3600;
  if (interval > 1) return Math.floor(interval) + " hours ago";
  interval = seconds / 60;
  if (interval > 1) return Math.floor(interval) + " minutes ago";
  return Math.floor(seconds) + " seconds ago";
}
